"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FbDataStore = exports.FbTransaction = exports.FbSentinels = void 0;
const firebase = require("firebase/app");
require("firebase/firestore");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
/**
 * Specify a modifier for a field instead of a direct field value
 */
class FbSentinels {
    increment(number) {
        return firebase.firestore.FieldValue.increment(number);
    }
    serverTimestamp() {
        return firebase.firestore.FieldValue.serverTimestamp();
    }
    delete() {
        return firebase.firestore.FieldValue.delete();
    }
    arrayUnion(...elements) {
        return firebase.firestore.FieldValue.arrayUnion(...elements);
    }
    arrayRemove(...elements) {
        return firebase.firestore.FieldValue.arrayRemove(...elements);
    }
}
exports.FbSentinels = FbSentinels;
class FbTransaction {
    constructor(store, txn) {
        this.store = store;
        this.txn = txn;
    }
    create(collectionPath, data) {
        return __awaiter(this, void 0, void 0, function* () {
            let firestore = this.store.firestore;
            let docRef = firestore.collection(collectionPath).doc();
            try {
                yield this.txn.set(docRef, data);
            }
            catch (e) {
                handleError(e, `datastoreTransaction.create('${collectionPath}', ...)`, data);
            }
            data.id = docRef.id;
            return data;
        });
    }
    read(docPath) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return (_a = (yield this.txn.get(this.store.firestore.doc(docPath)))) === null || _a === void 0 ? void 0 : _a.data();
            }
            catch (e) {
                handleError(e, `datastoreTransaction.read('${docPath}')`);
            }
        });
    }
    update(docPath, data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.txn.update(this.store.firestore.doc(docPath), data);
            }
            catch (e) {
                handleError(e, `datastoreTransaction.update('${docPath}', ...)`, data);
            }
        });
    }
    set(docPath, data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.txn.set(this.store.firestore.doc(docPath), data);
            }
            catch (e) {
                handleError(e, `datastoreTransaction.set('${docPath}', ...)`, data);
            }
        });
    }
    delete(docPath) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.txn.delete(this.store.firestore.doc(docPath));
            }
            catch (e) {
                handleError(e, `datastoreTransaction.delete('${docPath}', ...)`);
            }
        });
    }
    readAll(docPaths) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield Promise.all(docPaths
                .map(docPath => this.store.firestore.doc(docPath))
                .map(x => this.txn.get(x))))
                .map(x => x.data());
        });
    }
}
exports.FbTransaction = FbTransaction;
class FbQuery {
    constructor(_query) {
        this._query = _query;
    }
    where(fieldName, operator, value) {
        return new FbQuery(this._query.where(fieldName, operator, value));
    }
    get() {
        return __awaiter(this, void 0, void 0, function* () {
            let snapshot = yield this._query.get();
            return snapshot.docs.map(x => x.data());
        });
    }
}
function lazyConnection(options) {
    let obs = new rxjs_1.Observable(observer => {
        let subject = new rxjs_1.Subject();
        let subscription = subject.subscribe(observer);
        options.start(subject);
        return () => {
            subscription.unsubscribe();
            options.stop();
        };
    });
    return obs.pipe(operators_1.publish()).refCount();
}
function printError(error, operationName, data) {
    console.groupCollapsed(`Error '${error.message}' during ${operationName}`);
    console.log(`Details:`);
    console.error(error);
    if (data) {
        console.log(`Data:`);
        console.dir(data);
    }
    console.groupEnd();
}
function handleError(error, operationName, data) {
    printError(error, operationName, data);
    throw error;
}
class FbDataStore {
    constructor(firestore) {
        this.firestore = firestore;
        this.sentinels = new FbSentinels();
    }
    set(docPath, data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.firestore.doc(docPath).set(data);
            }
            catch (e) {
                handleError(e, `datastore.set('${docPath}', ...)`, data);
            }
        });
    }
    create(collectionPath, data) {
        return __awaiter(this, void 0, void 0, function* () {
            let colRef = this.firestore.collection(collectionPath);
            let docRef;
            try {
                docRef = yield colRef.add(data);
            }
            catch (e) {
                handleError(e, `datastore.create('${collectionPath}', ...)`, data);
            }
            data.id = docRef.id;
            return data;
        });
    }
    transact(handler) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.firestore.runTransaction((fsTxn) => __awaiter(this, void 0, void 0, function* () {
                let txn = new FbTransaction(this, fsTxn);
                return yield handler(txn);
            }));
        });
    }
    read(docPath) {
        return __awaiter(this, void 0, void 0, function* () {
            let docRef = this.firestore.doc(docPath);
            let snap;
            try {
                snap = yield docRef.get();
            }
            catch (e) {
                handleError(e, `datastore.read('${docPath}')`);
            }
            let t = snap.data();
            if (t)
                t.id = docRef.id;
            return t;
        });
    }
    query(collectionPath) {
        return new FbQuery(this.firestore.collection(collectionPath));
    }
    watch(docPath) {
        let doc = this.firestore.doc(docPath);
        let unsub;
        return lazyConnection({
            start: (subject) => {
                unsub = doc.onSnapshot({
                    next: snap => subject.next(snap.data()),
                    error: error => (printError(error, `watch('${docPath}')`), subject.error(error))
                });
            },
            stop: () => unsub()
        });
    }
    watchForChanges(collectionPath, params) {
        var _a, _b;
        let collection = this.firestore.collection(collectionPath);
        if (params === null || params === void 0 ? void 0 : params.order)
            collection = collection.orderBy((_a = params === null || params === void 0 ? void 0 : params.order) === null || _a === void 0 ? void 0 : _a.field, (_b = params === null || params === void 0 ? void 0 : params.order) === null || _b === void 0 ? void 0 : _b.direction);
        if (params === null || params === void 0 ? void 0 : params.limit)
            collection = collection.limit(params === null || params === void 0 ? void 0 : params.limit);
        if (params === null || params === void 0 ? void 0 : params.startAfter)
            collection = collection.startAfter(params === null || params === void 0 ? void 0 : params.startAfter);
        let unsub;
        return lazyConnection({
            start: (subject) => unsub = collection.onSnapshot(snap => subject.next(snap.docChanges().map(x => ({ type: x.type, document: x.doc.data() })))),
            stop: () => unsub()
        });
    }
    watchAll(collectionPath, params) {
        var _a, _b;
        let collection = this.firestore.collection(collectionPath);
        if (params === null || params === void 0 ? void 0 : params.order)
            collection = collection.orderBy((_a = params === null || params === void 0 ? void 0 : params.order) === null || _a === void 0 ? void 0 : _a.field, (_b = params === null || params === void 0 ? void 0 : params.order) === null || _b === void 0 ? void 0 : _b.direction);
        if (params === null || params === void 0 ? void 0 : params.limit)
            collection = collection.limit(params === null || params === void 0 ? void 0 : params.limit);
        if (params === null || params === void 0 ? void 0 : params.startAfter)
            collection = collection.startAfter(params === null || params === void 0 ? void 0 : params.startAfter);
        let unsub;
        return lazyConnection({
            start: (subject) => unsub = collection.onSnapshot({
                next: snap => subject.next(snap.docs.map(x => x.data())),
                error: error => (printError(error, `watchAll('${collectionPath}')`), subject.error(error))
            }),
            stop: () => unsub()
        });
    }
    listAll(collectionPath, params) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            let collection = this.firestore.collection(collectionPath);
            if (params === null || params === void 0 ? void 0 : params.order)
                collection = collection.orderBy((_a = params === null || params === void 0 ? void 0 : params.order) === null || _a === void 0 ? void 0 : _a.field, (_b = params === null || params === void 0 ? void 0 : params.order) === null || _b === void 0 ? void 0 : _b.direction);
            if (params === null || params === void 0 ? void 0 : params.limit)
                collection = collection.limit(params === null || params === void 0 ? void 0 : params.limit);
            if (params === null || params === void 0 ? void 0 : params.startAfter)
                collection = collection.startAfter(params === null || params === void 0 ? void 0 : params.startAfter);
            let snap;
            try {
                snap = yield collection.get();
            }
            catch (e) {
                handleError(e, `datastore.listAll('${collectionPath}')`);
            }
            return snap
                .docs
                .map(x => Object.assign({}, x.data(), { id: x.id }));
        });
    }
    update(docPath, data) {
        return __awaiter(this, void 0, void 0, function* () {
            let docRef = this.firestore.doc(docPath);
            try {
                yield docRef.set(data, { merge: true });
            }
            catch (e) {
                handleError(e, `datastore.update('${docPath}')`);
            }
        });
    }
    delete(docPath) {
        return __awaiter(this, void 0, void 0, function* () {
            let docRef = this.firestore.doc(docPath);
            try {
                yield docRef.delete();
            }
            catch (e) {
                handleError(e, `datastore.delete('${docPath}')`);
            }
        });
    }
    mirrorInTransaction(txn, primaryKey, mirrorKeys, data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!data)
                    data = yield txn.read(primaryKey);
            }
            catch (e) {
                console.error(`Caught error while fetching content for mirroring from '${primaryKey}' (would have mirrored to ${mirrorKeys.length} keys: ${mirrorKeys.join(', ')})`);
                console.error(e);
                console.groupCollapsed('Debug Details');
                console.dir(`Object view of error:`);
                console.dir(e);
                console.groupEnd();
                throw e;
            }
            if (!data)
                throw new Error(`No such object ${primaryKey}`);
            try {
                yield Promise.all(mirrorKeys.map(key => txn.set(key, data)));
            }
            catch (e) {
                console.error(`Caught error while mirroring content from '${primaryKey}' to ${mirrorKeys.length} keys: ${mirrorKeys.join(', ')}`);
                console.error(e);
                console.groupCollapsed('Debug Details');
                console.dir(`Object view of error:`);
                console.dir(e);
                console.log(`The data being mirrored:`);
                console.dir(data);
                console.groupEnd();
                throw e;
            }
        });
    }
    mirror(primaryKey, mirrorKeys, data) {
        return __awaiter(this, void 0, void 0, function* () {
            let primaryRef = this.firestore.doc(primaryKey);
            let mirrorRefs = mirrorKeys.map(x => this.firestore.doc(x));
            try {
                if (!data)
                    data = (yield primaryRef.get()).data();
            }
            catch (e) {
                console.error(`Caught error while fetching content for mirroring from '${primaryKey}' (would have mirrored to ${mirrorKeys.length} keys: ${mirrorKeys.join(', ')})`);
                console.error(e);
                console.groupCollapsed('Debug Details');
                console.dir(`Object view of error:`);
                console.dir(e);
                console.groupEnd();
                throw e;
            }
            if (!data)
                throw new Error(`No such object ${primaryKey}`);
            try {
                yield Promise.all(mirrorRefs.map(ref => ref.set(data)));
            }
            catch (e) {
                console.error(`Caught error while mirroring content from '${primaryKey}' to ${mirrorKeys.length} keys: ${mirrorKeys.join(', ')}`);
                console.error(e);
                console.groupCollapsed('Debug Details');
                console.dir(`Object view of error:`);
                console.dir(e);
                console.log(`The data being mirrored:`);
                console.dir(data);
                console.groupEnd();
                throw e;
            }
        });
    }
    createAndMirror(collectionPath, data, mirrorKeys) {
        return __awaiter(this, void 0, void 0, function* () {
            let record;
            yield this.transact((txn) => __awaiter(this, void 0, void 0, function* () {
                try {
                    record = yield txn.create(collectionPath, data);
                }
                catch (e) {
                    console.error(`Caught error while creating entry in '${collectionPath}' (and mirroring to ${mirrorKeys.length} keys: ${mirrorKeys.join(', ')})`);
                    console.error(e);
                    console.groupCollapsed('Debug Details');
                    console.dir(`Object view of error:`);
                    console.dir(e);
                    console.log(`The data being written:`);
                    console.dir(data);
                    console.groupEnd();
                    throw e;
                }
                yield this.mirrorInTransaction(txn, `${collectionPath}/${record.id}`, mirrorKeys.map(key => key.replace(/:id/g, record.id)), record);
            }));
            try {
                record = yield this.create(collectionPath, data);
            }
            catch (e) {
                console.error(`Caught error while creating entry in '${collectionPath}' (and mirroring to ${mirrorKeys.length} keys: ${mirrorKeys.join(', ')})`);
                console.error(e);
                console.groupCollapsed('Debug Details');
                console.dir(`Object view of error:`);
                console.dir(e);
                console.log(`The data being written:`);
                console.dir(data);
                console.groupEnd();
                throw e;
            }
            yield this.mirror(`${collectionPath}/${record.id}`, mirrorKeys.map(key => key.replace(/:id/g, record.id), record));
            return record;
        });
    }
    multiUpdate(docPaths, data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield Promise.all(docPaths.map(path => this.update(path, data)));
            }
            catch (e) {
                console.error(`Caught error during multi-update to ${docPaths.length} keys: ${docPaths.join(', ')})`);
                console.error(e);
                console.groupCollapsed('Debug Details');
                console.dir(`Object view of error:`);
                console.dir(e);
                console.log(`The data being written:`);
                console.dir(data);
                console.groupEnd();
                throw e;
            }
        });
    }
}
exports.FbDataStore = FbDataStore;
//# sourceMappingURL=datastore.firestore-browser.js.map